import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Alert, Box, Grid, Typography } from '@mui/material';
import { callApiWithData } from '../api/call-api';
import Meal, { mapMealFromApi } from '../models/meal';
import MealItem from '../components/Meal/MealItem';
import Loader from '../components/UI/General/Loader';

const headings: Record<string, string> = {
  new: 'Něco nového',
  'last-cooked': 'Něco, co jsem dlouho nevařil/a',
  healthy: 'Něco zdravého',
  favorites: 'Jeden z oblíbených',
};

const emptyMessages: Record<string, string> = {
  new: 'Všechny recepty už máš vyzkoušené!',
  healthy: 'Žádné recepty nemají dostatečné hodnocení zdravosti',
  favorites: 'Zatím nemáš žádné oblíbené recepty',
  'last-cooked': 'Ještě jsi nic nevařil/a',
};

const validFilters = ['new', 'last-cooked', 'healthy', 'favorites'];

const CookingGuidanceResults = () => {
  const { filter } = useParams<{ filter: string }>();
  const navigate = useNavigate();
  const [meals, setMeals] = useState<Meal[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!filter || !validFilters.includes(filter)) {
      navigate('/cooking-guidance', { replace: true });
      return;
    }

    setLoading(true);
    setError(null);
    callApiWithData('/chef-meals', { filter }, 'POST')
      .then((response) => {
        const meals: Meal[] = response.meals.map(mapMealFromApi);
        setMeals(meals);
      })
      .catch(() => {
        setError('Nepodařilo se načíst recepty. Zkuste to prosím znovu.');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [filter, navigate]);

  const heading = filter ? headings[filter] : '';
  const emptyMessage = filter ? emptyMessages[filter] : '';

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        {heading}
      </Typography>

      {loading && <Loader />}

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {!loading && !error && meals.length === 0 && (
        <Typography variant="body1" color="text.secondary">
          {emptyMessage}
        </Typography>
      )}

      {!loading && !error && meals.length > 0 && (
        <Grid container spacing={{ xs: 2, md: 4 }}>
          {meals.map((meal) => (
            <Grid key={meal.id} item xs={12} md={6}>
              <MealItem meal={meal} />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default CookingGuidanceResults;
